// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import searchFiltersReducer from "./searchFiltersSlice";
import jobDetailsReducer from "./jobDetailsSlice";
import smartMatchReducer from "./smartMatchSlice";
const filtersPersistConfig = {
  key: "searchFilters",
  storage,
  whitelist: ["searchTerm", "statusNames", "statusValues", "startDate", "endDate"],
};

const persistedFiltersReducer = persistReducer(filtersPersistConfig, searchFiltersReducer);

export const store = configureStore({
  reducer: {
    searchFilters: persistedFiltersReducer,
    jobDetails: jobDetailsReducer,
    smartMatch: smartMatchReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // needed for redux-persist
    }),
});

export const persistor = persistStore(store);
